// src/store/transito/mutations.ts
import { TransitoState, TransitoFilters, TransitoRow } from ".";

export default {
  setTransitoData(state: TransitoState, data: TransitoRow[]) {
    state.transitoData = data;
  },

  setNextPageUrl(state: TransitoState, url: string | null) {
    state.next_page_url = url;
  },
  setPrevPageUrl(state: TransitoState, url: string | null) {
    state.prev_page_url = url;
  },
  setFirstPageUrl(state: TransitoState, url: string | null) {
    state.first_page_url = url;
  },
  setLastPageUrl(state: TransitoState, url: string | null) {
    state.last_page_url = url;
  },

  setLastPage(state: TransitoState, page: number) {
    state.last_page = page;
  },
  setCurrentPage(state: TransitoState, page: number) {
    state.current_page = page;
  },

  setTotal(state: TransitoState, total: number) {
    state.total = total;
  },
  setFrom(state: TransitoState, from: number | null) {
    state.from = from;
  },
  setTo(state: TransitoState, to: number | null) {
    state.to = to;
  },

  setLoading(state: TransitoState, loading: boolean) {
    state.loading = loading;
  },
  setIsLoadingMore(state: TransitoState, loading: boolean) {
    state.isLoadingMore = loading;
  },

  setErrorMessage(state: TransitoState, message: string | null) {
    state.errorMessage = message;
  },

  SET_SELECTED_FILTERS(state: TransitoState, selectedFilters: TransitoFilters) {
    state.selectedFilters = selectedFilters;
  },

  deleteTransito(state: TransitoState, item: number) {
    state.transitoData = state.transitoData.filter((r) => r.item !== item);
  },

  // elimina varios items
  deleteTransitoItems(state: TransitoState, items: number[]) {
    const set = new Set(items);
    state.transitoData = state.transitoData.filter((r) => !set.has(r.item));
  },

  // elimina todo lo que pertenezca a un pedido (id)
  deleteTransitoPedido(state: TransitoState, pedidoId: number) {
    state.transitoData = state.transitoData.filter((r) => r.id !== pedidoId);
  },

  upsertTransito(state: TransitoState, row: TransitoRow) {
    const idx = state.transitoData.findIndex((r) => r.item === row.item);
    if (idx >= 0) state.transitoData[idx] = row;
    else state.transitoData.unshift(row);
  },
};